import { on } from '@ngrx/store';
import { specialFeaturesActions } from '../actions';
import { IDashboardState } from '../states';

const onSetIsShelfReportActive = on(
  specialFeaturesActions.setIsShelfReportActive,
  (state: IDashboardState, { isShelfReportActive }) => ({
    ...state,
    specialFeatures: {
      ...state.specialFeatures,
      isShelfReportActive,
    },
  }),
);

const onSetIsSpecialLabelActive = on(
  specialFeaturesActions.setIsSpecialLabelActive,
  (state: IDashboardState, { isSpecialLabelActive }) => ({
    ...state,
    specialFeatures: {
      ...state.specialFeatures,
      specialLabel: {
        ...state.specialFeatures.specialLabel,
        isSpecialLabelActive,
      },
    },
  }),
);

const onSetSpecialLabelOptions = on(
  specialFeaturesActions.setSpecialLabelOptions,
  (state: IDashboardState, options) => ({
    ...state,
    specialFeatures: {
      ...state.specialFeatures,
      specialLabel: {
        ...state.specialFeatures.specialLabel,
        options: {
          ...state.specialFeatures.specialLabel.options,
          ...options,
        },
      },
    },
  }),
);

const onSetIsScanOrdersActive = on(
  specialFeaturesActions.setIsScanOrdersActive,
  (state: IDashboardState, { isScanOrdersActive }) => ({
    ...state,
    specialFeatures: {
      ...state.specialFeatures,
      isScanOrdersActive,
    },
  }),
);

const specialFeaturesActionHandlers = [
  onSetIsShelfReportActive,
  onSetIsSpecialLabelActive,
  onSetSpecialLabelOptions,
  onSetIsScanOrdersActive,
];

export default specialFeaturesActionHandlers;
